import { DefaultStatus } from "types/models.ts";

interface StatusCellProps {
    status: string;
    customLabels?: {
        [key: string]: string;
    };
    customStatusMap?: {
        [key: string]: {
            label: string;
            color: string;
        };
    };
    hideLabel?: boolean;
}

const defaultStatusMap: { [key in DefaultStatus]: { label: string; color: string } } = {
    [DefaultStatus.Success]: { label: "Success", color: "bg-green-500" },
    [DefaultStatus.Error]: { label: "Error", color: "bg-mediumRed2" },
    [DefaultStatus.Warning]: { label: "Warning", color: "bg-lightYellow" },
};

const fallback = { label: "Unknown", color: "bg-gray-400" };

export const StatusCell = ({ status, customLabels = {}, customStatusMap = {}, hideLabel = false }: StatusCellProps) => {
    const mergedStatusMap = { ...defaultStatusMap, ...customStatusMap };
    const current = mergedStatusMap[status as keyof typeof mergedStatusMap] || fallback;

    const label = customLabels[status] || current.label;
    const color = current.color;

    return (
        <div className="flex items-center gap-2">
            <span className={`inline-block w-2 h-2 rounded-lg ${color}`} />
            {!hideLabel && <span>{label}</span>}
        </div>
    );
};
